import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <div className="gradient-bg text-white">
      <div className="travel-container py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Plan Your Trip with AI
          </h1>
          <p className="text-lg md:text-xl mb-8 text-gray-100">
            TravelAI helps you find flights, hotels, create custom itineraries, and more—all powered by artificial intelligence.
          </p>
          <div className="flex justify-center">
            <Button 
              size="lg" 
              className="bg-white text-travel-blue hover:bg-gray-100"
              onClick={() => navigate("/assistant")}
            >
              <Search className="mr-2 h-4 w-4" />
              Start Planning
            </Button>
          </div>
        </div>
      </div>

      {/* Wave divider */}
      <div className="w-full">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-full h-auto">
          <path 
            fill="#FFFFFF" 
            fillOpacity="1" 
            d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,56C1248,48,1344,32,1392,24L1440,16L1440,100L1392,100C1344,100,1248,100,1152,100C1056,100,960,100,864,100C768,100,672,100,576,100C480,100,384,100,288,100C192,100,96,100,48,100L0,100Z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;
